export default (obj, pathArray, defaultValue) =>
	// Example:
	// const b = getIn({a:{b:1}} ,['a','b'], 0 )
	pathArray.reduce((memo, val) => {
		if (!memo) return defaultValue;
		if (typeof memo === 'undefined') return defaultValue;
		return memo[val];
	}, obj);
